import wavesColorized from "assets/images/wave-colorized.png";
import wavesGray from "assets/images/wave.png";

export const waveList = [
  {
    name: "waves #1",
    img: wavesColorized,
  },
  {
    name: "waves #2",
    img: wavesColorized,
  },
  {
    name: "waves #??",
    img: wavesGray,
  },
  {
    name: "waves #??",
    img: wavesGray,
  },
  {
    name: "waves #??",
    img: wavesGray,
  },
];
